import React, { FC } from 'react';

import { FeedbackFormAnswer, FeedbackFormElement, FeedbackFormElementTypeId } from '@packages/models/api';

import { FeedbackFormElementComponent, FeedbackFormElements } from './feedback-form-elements';

export type IconSizes =
    | {
          smaller: number;
          small: number;
      }
    | undefined;

export interface FeedbackFormElementRenderProps {
    item: FeedbackFormElement;
    readOnly?: boolean;
    useDrawerStyle?: boolean;
    onAnswerChange?: (answer: FeedbackFormAnswer) => void;
    value?: string;
}

interface FeedbackFormElementProps extends FeedbackFormElementRenderProps {
    dropdownRenderer: (props: FeedbackFormElementRenderProps) => JSX.Element;
}

export const BaseFeedbackFormElement: FC<FeedbackFormElementProps> = ({
    dropdownRenderer,
    onAnswerChange,
    item,
    readOnly,
    useDrawerStyle = false,
}) => {
    //@ts-ignore
    if (item.formElementTypeId === FeedbackFormElementTypeId.Dropdown) {
        return dropdownRenderer({ item, readOnly, onAnswerChange });
    }

    //@ts-ignore
    const FormElementComponent: FeedbackFormElementComponent = FeedbackFormElements?.[item.formElementTypeId];

    if (!FormElementComponent) {
        return null;
    }

    let customStyles = {};
    let iconSizes: IconSizes = undefined;

    if (useDrawerStyle) {
        customStyles = {
            elementLabel: {
                fontSize: 11,
                fontWeight: 700,
                textTransform: 'uppercase',
            },
            elementLabelPadding: {
                marginBottom: 12,
            },
            selectOptionWrapper: {
                paddingVertical: 4,
            },
            expandIcon: {
                width: 20,
            },
            checkbox: {
                width: 24,
                // paddingRight: 10,
            },
            checkboxAndRadioText: {
                fontSize: 15,
                paddingLeft: 5,
                paddingRight: 10,
            },
            inputText: {
                fontSize: 15,
            },
            labelWrapper: {
                flexDirection: 'column',
            },
            range: {
                messagePlaceholderText: {
                    fontSize: 11,
                },
                knobText: {
                    fontSize: 13,
                    fontWeight: 600,
                },
                messageText: {
                    fontSize: 11,
                },
            },
            radio: {
                width: 18,
            },
        };

        iconSizes = {
            smaller: 18,
            small: 20,
        };
    }

    return (
        <FormElementComponent
            customStyles={customStyles}
            iconSizes={iconSizes}
            readOnly={readOnly}
            onAnswerChange={onAnswerChange}
            {...item}
        />
    );
};
